import { PropsWithChildren, ReactNode, Suspense } from 'react'
import { ErrorBoundary, FallbackProps } from 'react-error-boundary'

type WithSuspenseProps = {
  fallback: ReactNode
  active?: boolean
}

export const WithSuspense = ({
  active,
  fallback,
  children,
}: PropsWithChildren<WithSuspenseProps>) => {
  if (!active) {
    return children
  }

  return <Suspense fallback={fallback}>{children}</Suspense>
}

type WithErrorBoundaryProps = {
  active?: boolean
  fallback: ((props: FallbackProps) => ReactNode) | ReactNode
}

export const WithErrorBoundary = ({
  active,
  fallback,
  children,
}: PropsWithChildren<WithErrorBoundaryProps>) => {
  if (!active) {
    return children
  }

  return (
    <ErrorBoundary
      {...(typeof fallback === 'function'
        ? { fallbackRender: fallback }
        : { fallback })}
    >
      {children}
    </ErrorBoundary>
  )
}

type WithSuspenseBoundaryProps = {
  active?: boolean
  error: ((props: FallbackProps) => ReactNode) | ReactNode
  loading: ReactNode
}

export const WithSuspenseBoundary = ({
  active,
  error,
  loading,
  children,
}: PropsWithChildren<WithSuspenseBoundaryProps>) => {
  return (
    <WithErrorBoundary active={active} fallback={error}>
      <WithSuspense active={active} fallback={loading}>
        {children}
      </WithSuspense>
    </WithErrorBoundary>
  )
}
